export const BULK_SELECT = 'BULK_SELECT';